import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ErrorState } from '../../../components/states';
// import { useTranslation } from 'react-i18next';
import ExtraMaterialForm from '../../../components/forms/ExtraMaterialForm';
import Loader from '../../../components/Loader';
import { useFetch } from '../../../hooks/useFetch';

export default function ExtraMaterialsViewPage() {
  // const { t } = useTranslation();
  const { itemId } = useParams();

  const { requestApi, data, error } = useFetch(`/v1/admin/extra_materials/${itemId}`);

  useEffect(() => {
    requestApi('get');
  }, []);

  if (error) {
    return <ErrorState onRetry={() => requestApi('get')} />;
  }

  return data?.data ? <ExtraMaterialForm defaultValues={data?.data} view /> : <Loader />;
}
